import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customMqCustSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getCommCodes(codeType) {
		//console.log('codeType', codeType);
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getPwaApcnList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		/*날짜 포멧변환*/
		let pwaStartDt, pwaEndDt;
		//날짜 값이 없으면 날짜 포멧을 할수가 없다.
		if (searchParams.pwaStartDt) {
			pwaStartDt = moment(searchParams.pwaStartDt).format('YYYYMMDD');
		} else {
			pwaStartDt = '';
		}

		if (searchParams.pwaEndDt) {
			pwaEndDt = moment(searchParams.pwaEndDt).format('YYYYMMDD');
		} else {
			pwaEndDt = '';
		}

		queryStr = objectToQuerystring({
			dlrCpnyCd: searchParams.dlrCpnyCd /*딜러점*/,
			carVin: searchParams.carVin /*차량VIN*/,
			prcStepGb: searchParams.prcStepGb /*처리단계*/,
			prcPwaDd: searchParams.prcPwaDd /*검색구분*/,
			prcRsltCd: searchParams.prcRsltCd /*검색구분*/,
			pwaStartDt: pwaStartDt /*신청일자from*/,
			pwaEndDt: pwaEndDt /*신청일자to*/,
			pmcId: searchParams.pmcId /*제품ID*/,
			aplcNm: searchParams.aplcNm /*신청자*/,
			pwaNo: searchParams.pwaNo,
			currentPage,
			pageUnit
		});

		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/pwaApcns` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getPwaApcnPopList(paramPwaNo) {
		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/pwaNo/${paramPwaNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	savePwaApcnPopup: ({ formData }) => {
		let url = `${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/1/`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	delApcnSwapInfoList: paramDelList => {
		let url = `${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/3/apcnSwapInfoList`;

		return client
			.post(url, paramDelList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	fileDownload: ({ params }) => {
		// console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downloadFiles`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	},
	apprDupCnt: ({ pwaApcnPopUp }) => {
		return client
			.post(
				`${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/1/pwaNo/${pwaApcnPopUp.pwaNo}/pmcId/${pwaApcnPopUp.pmcId}/milg/${pwaApcnPopUp.milg}/causPartNo/${pwaApcnPopUp.causPartNo}/selCtype/${pwaApcnPopUp.ctype}/chkDupCnt`
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	saveStateAppr: ({ pwaApcnPopUp }) => {
		let queryStr = '';

		queryStr = objectToQuerystring({
			eMailtitle: pwaApcnPopUp.eMailtitle,
			eMailContents: pwaApcnPopUp.eMailContents,
			prcsRslt: pwaApcnPopUp.prcsRslt,
			prcsStep: pwaApcnPopUp.prcsStep,
			apprContents: pwaApcnPopUp.apprContents
		});

		//console.log(queryStr);

		return client
			.post(
				`${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/2/pwaNo/${pwaApcnPopUp.pwaNo}/pmcId/${pwaApcnPopUp.pmcId}/milg/${pwaApcnPopUp.milg}/causPartNo/${pwaApcnPopUp.causPartNo}/dlrCpnyCd/${pwaApcnPopUp.aplcId}/selCtype/${pwaApcnPopUp.ctype}/apprA` +
					queryStr
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	deletePwaApcnPopup: delParam => {
		let queryStr = '';

		queryStr = objectToQuerystring({
			fileId: delParam.fileId /*fileId*/
		});

		//console.log('api CallUrl', `${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/3/pwaNo/${delParam.pwaNo}` + queryStr);

		return client
			.post(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/status/3/pwaNo/${delParam.pwaNo}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//팝업 pwa 목록 조회
	getPopupPwaApcnList: ({ popupSearchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		//console.log('popupSearchParams', popupSearchParams);

		queryStr = objectToQuerystring({
			dlrCpnyCd: popupSearchParams.dlrCpnyCd /*딜러점*/,
			carVin: popupSearchParams.carVin /*차량VIN*/,
			pwaNo: popupSearchParams.pwaNo /*처리단계*/,
			prcsRslt: popupSearchParams.prcsRslt /*처리단계*/,
			currentPage,
			pageUnit
		});

		//console.log('여기니queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/popupPwaApcns` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	chkPmcIdCampNo: param => {
		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/chkPmcIdCampNo/pmcId/${param}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	//팝업 pwa과 RO에서 사용년월 가져오는걸동시에 사용함
	getPwaUsedYear: param => {
		let queryStr = '';
		//console.log('popupSearchParams', popupSearchParams);
		/*
		oemSaleD: moment(param.oemSaleD).format('YYYYMMDD'), //OEM판매일자.
				dgnDd: moment(this.pwaApcnPopUp.dgnDd).format('YYYYMMDD') //진단일자.
		*/

		queryStr = objectToQuerystring({
			oemSaleDd: param.oemSaleD, //OEM판매일자.
			dgnDd: param.dgnDd //진단일자.,
		});

		//console.log('여기니queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/pwaUsedYear` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
